import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
var POSITION = {
  gauche: 'align-items-center text-left',
  droite: 'align-items-center text-right',
  haut: 'align-items-start text-center',
  bas: 'align-items-end text-center'
};
export default {
  name: 'TrendMainImage',
  props: {
    position: {
      type: String,
      default: ''
    },
    released: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    subhead: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#3c3c3b'
    },
    fontColor: {
      type: String,
      default: '#3c3c3b'
    }
  },
  methods: {
    scrollSection: function scrollSection() {
      var x = window.pageYOffset || document.documentElement.scrollTop;
      var y = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      if (x >= y) {
        window.scrollTo({
          top: y - x,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      }
    },
    changePosition: function changePosition(position) {
      return POSITION[position] || 'align-items-center text-center';
    }
  }
};